import axios from 'axios';
import { logger } from '@fiverr-private/perseus';
import pathfinder from '@fiverr-private/pathfinder';

const FETCH_RECOMMENDATIONS_URL = 'lohp_fetch_recommendations';

const getRecommendationsData = async(queryParams) => {
    const uri = pathfinder(FETCH_RECOMMENDATIONS_URL, null, { query: queryParams });

    try {
        const { data } = await axios.get(uri);
        if (!data.gigs) {
            throw new Error('Empty gigs for recommendations ajax');
        }

        return data;
    } catch (error) {
        logger.error(error, { queryParams });
        throw error;
    }
};

export default getRecommendationsData;
